import React from 'react';
import { Box, FormControlLabel, Switch, Typography } from '@mui/material';

interface NotificationHeaderProps {
  showOnlyUnread: boolean;
  handleUnreadOnlyToggle: () => void;
}

const NotificationHeader: React.FC<NotificationHeaderProps> = (props) => {
  return (
    <Box
      sx={{
        px: 2,
        py: 1.5,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 1.5,
        borderBottom: 1,
        borderColor: 'divider',
        bgcolor: 'background.paper',
      }}
    >
      <Typography variant="subtitle1" sx={{ fontWeight: 600, letterSpacing: '-0.01em' }}>
        Notifications
      </Typography>
      <FormControlLabel
        control={
          <Switch
            checked={props.showOnlyUnread}
            onChange={props.handleUnreadOnlyToggle}
            size="small"
          />
        }
        label={
          <Typography variant="caption" color="text.secondary" sx={{ userSelect: 'none' }}>
            Unread only
          </Typography>
        }
        sx={{ m: 0, mr: -0.5, gap: 0.75 }}
        labelPlacement="start"
      />
    </Box>
  );
};

export default NotificationHeader;
